import React, { useState } from 'react'
import { ToastContainer, toast, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Helmet } from 'react-helmet'

const Contact = () => {

    const [user, setuser] = useState({
        name: '',
        email: "",
        message: ""
    })

    const host = "http://localhost:5000";
    const handleSubmit = async (e) => {
        e.preventDefault();
        const response = await fetch(`https://my-portfolio-z6er.vercel.app/api/user`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ email: user.email, name: user.name, message: user.message })
        })
        const data = await response.json();
        if (data.success) {
            toast.success(data.message, {
                position: "top-left",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
                transition: Slide,
            });
            setuser({
                name: '', email: '', message: ''
            })
        }
        else {
            toast.error(data.message, {
                position: "top-left",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
                transition: Slide,
            });
        }
        console.log(data);
    }

    const handleChange = (e) => {
        setuser((prevUser) => ({
            ...prevUser,
            [e.target.name]: e.target.value,
        }));
    };

    return (
        <div style={{ height: "100vh", overflow: "hidden" }}>
            <Helmet>
                <title>Contact | Paresh Chandra Pothal</title>
                <meta name="description" content="Get in touch with Paresh Chandra Pothal for project collaborations, inquiries, or freelance opportunities." />
                <meta name="keywords" content="contact, Paresh Chandra Pothal, collaborations, inquiries, freelance, projects, get in touch" />
                <meta name="author" content="Paresh Chandra Pothal" />
            </Helmet>
            <ToastContainer
                position="top-left"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
                transition={Slide}
            />
            <section style={{ backgroundColor: "rgba(21, 21, 21, 1)" }} className="text-gray-600 body-font relative flex justify-center items-center h-full">
                <div className="container px-0 py-0 mx-auto flex sm:flex-nowrap flex-wrap h-full">
                    <div className="lg:w-full md:w-full w-full bg-gray-300 rounded-lg overflow-hidden p-0 flex items-center justify-center relative h-full">
                        <iframe
                            width="100%"
                            height="100%"
                            className="absolute inset-0"
                            frameBorder="0"
                            title="map"
                            marginHeight="0"
                            marginWidth="0"
                            scrolling="no"
                            src="https://maps.google.com/maps?width=100%&height=600&hl=en&q=Koraput+(My%20Business%20Name)&ie=UTF8&t=&z=14&iwloc=B&output=embed
"
                            style={{
                                filter: "grayscale(1) contrast(1.2) opacity(0.4)"
                            }}
                        ></iframe>
                        <div style={{ backgroundColor: "rgba(21, 21, 21, 1)",color: "white" }} className="bg-white relative flex flex-wrap p-10 rounded shadow-md z-10 ">
                            <div className="lg:w-1/2 px-6">
                                <h2 className="title-font font-semibold  tracking-widest text-xs text-white">ADDRESS</h2>
                                <p className="mt-1">Amin Lane, Koraput, Odisha 764020</p>
                            </div>
                            <div className="lg:w-1/2 px-6 mt-4 lg:mt-0">
                                <h2 className="title-font font-semibold 0 tracking-widest text-xs text-white">EMAIL</h2>
                                <a className="text-green-500 leading-relaxed">pareshchandrapothal44@gmail.com</a>
                                <h2 className="title-font font-semibold  tracking-widest text-xs mt-4 text-white">PHONE</h2>
                                <p className="leading-relaxed">9777510561</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Contact
